import { Box, Stack } from '@mantine/core'
import type { ReactNode } from 'react'
import classes from './AutoScheduleSplit.module.css'

export function AutoScheduleSplit({ map, sidebar }: { map: ReactNode; sidebar: ReactNode }) {
  return (
    <Box
      h="100%"
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.25fr) minmax(28rem, 1fr)',
        gap: 'var(--mantine-spacing-lg)',
        minHeight: 0,
      }}
    >
      <Box h="100%" className={classes.mapPane}>
        {map}
      </Box>
      <Stack gap="md" h="100%" className={classes.sidebar}>
        {sidebar}
      </Stack>
    </Box>
  )
}
